import Button from '@material-ui/core/Button';
import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './RoadCondition.module.scss';
import './EditorsModal.scss';

const DiscardAlert=(props)=> {
  
    return (
      <>
        <Modal
          show={props.show}
          onHide={props.onHide}
          backdrop="static"
          // keyboard={false}
          centered
          dialogClassName="editorsModal noBody"
        >
          <Modal.Header closeButton>
            <Modal.Title>{props.modalBody}</Modal.Title>
          </Modal.Header>
          
          <Modal.Footer>
          <Button className={styles.submitButton} variant="contained" color="primary" onClick={props.onYes}> Yes</Button>
            <div style={{ width:"2px" }}></div>
            <Button className={styles.cancelButton} variant="outlined" color="secondary" onClick={props.onCancel}>
                         Cancel
            </Button>
                   
                </Modal.Footer>
        </Modal>
      </>
    );
  }
  export default DiscardAlert;